module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1234642"
    }
  }, [_c('b', [_vm._v("SAVORY BLUE CHEESE, WALNUT, "), _c('br'), _vm._v(" AND DATE RUGELACH")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1235442"
    }
  }, [_c('b', [_c('i', [_vm._v("Filling cream cheese dough with a mixture of blue cheese, walnuts, and dates turns rugelach into delicious pastries that go perfectly with a glass of red or white wine.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1236742"
    }
  }, [_c('b', [_vm._v("Prep: 40 minutes plus chilling and cooling "), _c('br'), _vm._v(" Bake: 30 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1237642"
    }
  }, [_vm._v("1 cup butter or margarine (2 sticks), softened")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1237942"
    }
  }, [_vm._v("1 package (8 ounces) cream cheese, softened")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1238242"
    }
  }, [_vm._v("2 cups all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1238542"
    }
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1239542"
    }
  }, [_vm._v("1½ cups walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1240642"
    }
  }, [_vm._v("4 ounces blue cheese, cut into small pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1240942"
    }
  }, [_vm._v("48 pitted dates (about 12 ounces)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1241242"
    }
  }, [_vm._v("1 large egg white")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1241642"
    }
  }, [_vm._v("1 teaspoon water")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1242142"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Prepare dough: In large bowl, with mixer at medium speed, beat butter and cream cheese until creamy, occasionally scraping bowl with rubber spatula. Reduce speed to low; gradually beat in flour and salt just until blended, occasionally scraping bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1244643"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Divide dough into 4 equal pieces; shape each into a disk. Wrap each disk in plastic wrap and refrigerate until dough is firm enough to roll, at least 4 hours or overnight. (Or place dough in freezer 1 hour if using butter, 1 hour 30 minutes if using margarine.)")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1246643"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" In food processor with knife blade attached, process ½ cup walnuts until finely chopped; transfer to small bowl and reserve. In same food processor bowl, process blue cheese and remaining 1 cup walnuts just until a coarse mixture forms.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1249443"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Preheat oven to 350°F. Line two large cookie sheets with foil; grease foil.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1250543"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("5.")])]), _vm._v(" On lightly floured surface, with floured rolling pin, roll one disk of dough into 10-inch round. (If dough is too cold to roll, let stand 5 to 10 minutes at room temperature to soften slightly.) With pastry wheel or knife, cut dough into 12 equal wedges (do not separate). Beginning 1 inch from edge, sprinkle ½ cup blue-cheese mixture in 2-inch-wide ring, leaving dough in center exposed. Place 1 whole date horizontally on wide curved end of each wedge. Starting at wide end, roll up each wedge, jelly-roll fashion. Place rugelach, point side down, 1 inch apart, on cookie sheet. Repeat with remaining dough (one disk at a time), blue-cheese mixture, and dates.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1256143"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("6.")])]), _vm._v(" In small bowl, lightly beat egg white with water. With pastry brush, brush rugelach with egg-white mixture and sprinkle evenly with reserved walnuts.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1257743"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("7.")])]), _vm._v(" Bake until golden, 30 to 35 minutes, rotating sheets between upper and lower racks halfway through baking. With wide spatula, immediately transfer rugelach to wire racks to cool. Store in airtight container up to 3 days, or in freezer up to 3 months. Makes 48 appetizers.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1260443"
    }
  }, [_vm._v("Each appetizer: about 125 calories, 2g protein, 10g carbohydrate, 9g total fat (4g saturated), 18mg cholesterol, 115mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3490f2c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c32_r1.vue
// module id = 162
// module chunks = 0